import { render, staticRenderFns } from "./my-report.vue?vue&type=template&id=22af3597&"
import script from "./my-report.vue?vue&type=script&lang=ts&"
export * from "./my-report.vue?vue&type=script&lang=ts&"
import style0 from "./my-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports